export const defaultColors = [
  '#1351AF',
  '#13CE66',
  '#FAD901',
  '#FF9E2C',
  '#FA5A7D',
  '#67BCBC',
  '#0033A5',
  '#00E0FF',
  '#7D67BC',
  '#6185DB',
  '#F03738',
  '#7000FF',
  '#C8FF2C',
  '#A497F6',
  '#88FFAC',
  '#3F0821',
  '#30426E',
  '#5FECFF',
  '#3F345E',
  '#FF69D5',
  '#D78AFD',
  '#0095FF',
  '#FA5A7D',
]
